export const useGtmEvents = () => {
  const gtm = useGtm();
  const store = useStore();
  const route = useRoute();
  const breakpoints = useBreakpoints();

  // Pushing event to GTM of the page view type
  const gtmPageTracking = () => {
    const { name, fullPath } = route;
    if (gtm && gtm.enabled())
      gtm.trackEvent({
        routeName: name,
        pageType: 'PageView',
        pageUrl: fullPath,
        pageTitle: (typeof document !== 'undefined' && document.title) || '',
        event: gtm.options.trackViewEventProperty
      });
  };

  // Pushing event to GTM of the pt-infogram-opened type
  const gtmInfogramTracking = (infogramId, title) => {
    if (gtm && gtm.enabled())
      gtm.trackEvent({
        infogramId,
        title,
        event: 'pt-infogram-opened'
      });
  };

  // Pushing event to GTM of the pt-register-opened type
  const gtmRegisterTracking = origin => {
    const { fullPath } = route;
    store.commit('profile/SET_BY_FIELD', { field: 'registerOrigin', value: origin });
    if (gtm && gtm.enabled())
      gtm.trackEvent({
        origin,
        pageUrl: fullPath,
        event: 'pt-register-opened'
      });
  };

  // Pushing event to GTM of the pt-register-success type
  const gtmRegisterSuccess = user => {
    const { communicationsConsent, userProfession, userPreferences } = user;
    const { fullPath } = route;
    if (gtm && gtm.enabled())
      gtm.trackEvent({
        origin: store.getters['profile/getByField']('registerOrigin'),
        pageUrl: fullPath,
        event: 'pt-register-success',
        communications_consent: communicationsConsent,
        cajamar_client: userProfession.cliente_cajamar,
        sector: userProfession.sector,
        subsectors: userPreferences.map(item => item.subsector_label)
      });
  };

  const gtmCXTierraRegisterSuccess = user => {
    const { fullPath } = route;
    if (gtm && gtm.enabled())
      gtm.trackEvent({
        pageUrl: fullPath,
        event: 'pt-cxtierra-register-success',
        dni: user.dni,
        zip: user.zip,
        mobile_number: user,
        company_name: user.company_name,
        mobile_prefix: user.mobile_prefix,
        company_position: user.company_position,
        cxtierra_consent: user.cxtierra_consent
      });
  };

  // Pushing event to GTM of the pt-subscribed-to-event type
  const gtmSubscribedToEvent = titleEvent => {
    if (gtm && gtm.enabled())
      gtm.trackEvent({
        pageUrl: route.fullPath,
        event: 'pt-subscribed-to-event',
        name: titleEvent
      });
  };

  // Pushing event to GTM of the pt-changed-seeker-option type
  const gtmChangedSeekerOption = indexValue => {
    if (gtm && gtm.enabled())
      gtm.trackEvent({
        indexValue,
        event: 'pt-changed-seeker-option'
      });
  };

  // Pushing event to GTM of the pt-search-results-page type
  const gtmSearchResultsPage = (indexValue, queryValue, facets) => {
    if (gtm && gtm.enabled())
      gtm.trackEvent({
        indexValue,
        queryValue,
        facets,
        event: 'pt-search-results-page'
      });
  };

  // Pushing event to GTM of the pt-ads-click type
  const gtmAdsClick = (ads, section) => {
    const { fullPath } = route;
    const { md } = breakpoints;
    if (gtm && gtm.enabled())
      gtm.trackEvent({
        campaignName: ads?.name,
        campaignUrl: ads?.link?.url,
        campaignSection: section,
        mediaUrl: !md.value ? ads?.media_mobile?.url : ads?.media_desktop?.url,
        pageUrl: fullPath,
        screenType: md.value ? 'desktop' : 'mobile',
        event: 'pt-ads-click'
      });
  };

  // Pushing event to GTM of the innova-agrotech-success
  const gtmInnovaAgrotechSuccess = () => {
    if (gtm && gtm.enabled())
      gtm.trackEvent({
        event: 'innova-agrotech-success'
      });
  };

  return {
    gtmPageTracking,
    gtmInfogramTracking,
    gtmRegisterTracking,
    gtmRegisterSuccess,
    gtmCXTierraRegisterSuccess,
    gtmSubscribedToEvent,
    gtmChangedSeekerOption,
    gtmSearchResultsPage,
    gtmAdsClick,
    gtmInnovaAgrotechSuccess
  };
};
